import { authApi } from '../services/features/authApi/authApi';
import { clearUser } from '../services/features/authApi/authSlice';
import store from '../store';

/**
 * Refreshes the JWT token if needed
 * @returns {Promise<boolean>} Whether the token was successfully refreshed
 */
export const refreshTokenIfNeeded = async (): Promise<boolean> => {
	const state = store.getState();
	// const { expiration } = state.authSlice;

	// Check if token needs to be refreshed
	// if (expiration) {
		// Dispatch the getRefreshToken query
		const resultAction = await store.dispatch(
			authApi.endpoints.getRefreshToken.initiate(null)
		);
		// console.log('RESULT ACTION', resultAction);
		// if (resultAction?.isSuccess && resultAction?.data?.expiration) {
		if (resultAction?.isSuccess) {
			console.log('✅ Token refreshed successfully');
            return true;
		} else {
			console.error('❌ Failed to refresh token');
			localStorage.clear();
			// Cookies.remove('token');
			store.dispatch(clearUser());
		}
	// }

	// const state = store.getState();
	// const { expiration } = state.authSlice;

	// if (expiration) {
	// 	try {
	// 		// Dispatch the getRefreshToken query
	// 		const resultAction = await store.dispatch(
	// 			authApi.endpoints.getRefreshToken.initiate(expiration)
	// 		);

	// 		if (resultAction?.data?.expiration) {
	// 			console.log('✅ Token refreshed successfully');
	// 			store.dispatch(setExpiration(resultAction.data.expiration));
	// 			return true;
	// 		} else {
	// 			console.error('❌ Failed to refresh token');
	// 			localStorage.clear();
	// 			Cookies.remove('token');
	// 			store.dispatch(clearUser());
	// 			return false;
	// 		}
	// 	} catch (error) {
	// 		console.error('🚨 Token refresh error:', error);
	// 		localStorage.clear();
	// 		Cookies.remove('token');
	// 		store.dispatch(clearUser());
	// 		return false;
	// 	}
	// }
	return false;
};

export const clearAppState = () => {
    localStorage.clear();
    // Cookies.remove('token');
    store.dispatch(clearUser());
}